module.exports = {
    moduleName: 'demoMng' // 模块名称
};